import script from "./AddEditSwapView.vue?vue&type=script&setup=true&lang=js"
export * from "./AddEditSwapView.vue?vue&type=script&setup=true&lang=js"

import "./AddEditSwapView.vue?vue&type=style&index=0&id=9d600e8c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d600e8c"]])

export default __exports__